import React, { useContext, useEffect } from 'react';
import { useRequest } from 'ahooks';
import styles from './index.module.scss';
import { Spin, Tooltip } from 'antd';
import { Empty, Paging, useSearchParams } from '@maxtropy/components';
import { apiV2EnergyOverviewEnvDeviceDataPost } from '@maxtropy/device-customer-apis-v2';
import { ShareDataUnityEnergyCockpitMapContext } from '../../../..';
import { getDefaultTime } from '@/pages/WgqAllMaps/utils';
import { keepTwoOrLine } from '@/utils/utils';
import lineBottomImg from '../../../../../../imgs/line_bottom.png';

interface EnvironmentalMonitorProps {
  visible?: boolean;
}

const EnvironmentalMonitor: React.FC<EnvironmentalMonitorProps> = ({ visible }) => {
  const { timeResolution, dateValue } = useContext(ShareDataUnityEnergyCockpitMapContext);
  const pagingInfo = useSearchParams(10);
  const { pageOffset, pageSize, setTotalCount } = pagingInfo;

  const { data, loading, run } = useRequest(
    async () => {
      const res = await apiV2EnergyOverviewEnvDeviceDataPost({
        fromTime: getDefaultTime(timeResolution!, dateValue)?.startTime,
        toTime: getDefaultTime(timeResolution!, dateValue)?.endTime,
        page: pageOffset,
        size: pageSize,
      });
      setTotalCount(res.total ?? 0);
      return res;
    },
    {
      manual: true,
      refreshDeps: [pageOffset, pageSize, timeResolution, dateValue],
      ready: !!timeResolution && !!dateValue,
    }
  );

  // 弹窗打开时组件挂载，直接调用接口；分页变化时也调用
  useEffect(() => {
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageOffset, pageSize]);

  return (
    <div className={styles.container}>
      <Spin spinning={loading}>
        {data?.list?.length === 0 ? (
          <Empty style={{ padding: 40 }} />
        ) : (
          <>
            <div className={styles.list_wrapper}>
              {data?.list?.map(item => (
                <div key={item.deviceId} className={styles.list_item}>
                  {/* 标题 */}
                  <div className={styles.item_header}>{item.deviceName}</div>
                  {/* 数据列表 */}
                  <div className={styles.item_content}>
                    {item.dataValues?.map((valueItem, index) => (
                      <div key={index} className={styles.data_row}>
                        <Tooltip title={valueItem.dataPropertyName}>
                          <span className={styles.data_label}>
                            {valueItem.dataPropertyName}
                            <img src={lineBottomImg} alt="" className={styles.line_bottom} />
                          </span>
                        </Tooltip>
                        <span className={styles.data_value}>
                          {keepTwoOrLine(valueItem.value)}
                          {valueItem.unit ? ` ${valueItem.unit}` : ''}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <Paging pagingInfo={pagingInfo} className={styles.paging} />
          </>
        )}
      </Spin>
    </div>
  );
};

export default EnvironmentalMonitor;
